import React, { useContext, useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useLocation } from 'react-router'
import { AuthContext } from '../../../Auth/AuthContext'
import LoadingLayer from '../../Global/LoadingLayer'

export const Error404 = () => {
  const { user } = useContext(AuthContext)
  const history = useHistory()
  const [loading, setLoading] = useState(true)
  const location = useLocation()

  useEffect(() => {
    setLoading(true)
    if (user?.userPermissions) {
      if(location.pathname === '/'){
        let index = 0
        if (
          user?.userPermissions.length > 1 &&
          user?.userPermissions[index].module_info?.relative_link === '/profile'
        )
          index = 1
        let path = '/'
        path = user?.userPermissions[index].module_info?.relative_link
        let subPath = user?.userPermissions[index]?.submodule_info?.relative_link
        if (subPath) {
          path = path + subPath
        }
        history.push(path) // Use history.push for redirection in React Router v5
      }
      setLoading(false)
    }
  }, [user.userPermissions])

  return (
    <>
      {loading ? (
        <LoadingLayer />
      ) : (
        <div className="container-notfound">
          <div className="error-page">
            <h2 className="headline text-warning"> 404</h2>

            <div className="error-content">
              <h1 className="title-notfound">
                <i className="fas fa-exclamation-triangle text-warning"></i>
                &nbsp;&nbsp;Página no encontrada!
              </h1>

              <span className="subtitle-notfound">
                La página que estás buscando no existe o ha sido movida. Por
                favor, haz clic en el botón de abajo para regresar a la página
                principal.
              </span>
              <div className="button-container">
                <Link
                  to={user?.logged ? '/dashboardMigrants/logged':"/dashboardMigrants"}
                  className="btn btn-migrates btn-sm mt-1"
                >
                  Ir a la página principal
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Error404
